export const CAMPANA_KEYS = {
    FechaInicio: "FechaInicio",
    FechaFin: "FechaFin",
    Nombre: "Nombre",
    IdCampana: "IdCampana",
    EstadoRegistro: "EstadoRegistro",
    EstadoProceso: "EstadoProceso",
    EsActivo: "EsActivo",
    RatioEficiencia: "RatioEficiencia",
    Anio: "Anio",
    FechaCierreDesarrollo:"FechaCierreDesarrollo",
    IdCampanaPrevia: "IdCampanaPrevia",

    IdPresupuestoRequerimiento: "IdPresupuestoRequerimiento",

    CRCampanaGuiaProcesoFileViewModel: "CRCampanaGuiaProcesoFileViewModel"

};